module.exports = __webpack_public_path__ + "static/media/pacman.7c8e3e67.png";


//////////////////
// WEBPACK FOOTER
// ./src/res/entries/pacman.png
// module id = 1081
// module chunks = 0